export enum RichTextBoxInputMethodKinds {
  /** 入力不可 */
  None = 0,
  /** フリー入力 */
  FreeInput = 1,
  /** HIS情報データ選択 */
  //  */HisInfoSelect = 2,
  /** ユーザ定義データ選択 */
  // UserDefinitionSelect = 3,
  /** MKSテンプレート入力 */
  MKSTemplate = 4,
  /** DYNAMICテンプレート入力 */
  DynamicTemplate = 5,
}
